import Vue from "vue"
import Vuex from "vuex"
import user from "./modules/user"
import basic from './modules/basic'
import survey from './modules/survey'



Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        user,
        basic,
        survey
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js